var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"no-gutters",attrs:{"fluid":""}},[_c('Header'),_c('div',[(_vm.games.length > 0)?_c('Games',{attrs:{"games":_vm.games}}):_c('div',[_c('p',[_vm._v("No games to display. Click \""),_c('b',[_vm._v("New Game")]),_vm._v("\" on the right top menu to create a new one.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }